<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems"/>
    <cms-wrapper-template></cms-wrapper-template>
  </div><!-- container -->
</template>

<script>
import CmsWrapperTemplate from '../components/cms/CmsWrapperTemplate'

export default {
  name: 'cms-template',
  metaInfo: {
    title: 'cms-template'
  },
  components: {
    CmsWrapperTemplate
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'トピックス',
        active: true
      },
      {
        text: '',
        active: true
      }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

  .heading-icon {
    text-align: left !important;
    justify-content: left !important;
    .heading {
      font-size: 16px !important;
    }
  }
  .list-group {
    margin-bottom: 10px;
  }
  .list-group.-note {
    color: $gray;
    margin-left: 20px;
    >.list-item.-note {
      list-style-type: none;
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 5px;
      &:before {
        content: '※';
        margin-left: -20px;
        margin-right: 10px;
      }
      @include mq-up(md) {
        font-size: 14px;
        line-height: 24px;
      }
      >.list-group.-note {
        >.list-item.-note {
          list-style-type: none;
          font-size: 12px;
          line-height: 18px;
          margin-top: 5px;
          margin-bottom: 5px;
          &:before {
            content: '※';
            margin-left: -16px;
            margin-right: 8px;
          }
          @include mq-up(md) {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CmsTemplate.vue